/**
 * SettlementLineService
 * Service for SettlementLine entity operations
 * Route: api/settlement-line
 * Controller: SettlementLineController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * SettlementLineService
 * Handles settlement line CRUD operations
 * Maps to /api/settlement-line endpoint
 */
export class SettlementLineService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SettlementLineService.DEFAULT_SERVICE_PATH,
            basePath: SettlementLineService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Settlement line with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate settlement line cache
     * POST /api/settlement-line/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate settlement line cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
SettlementLineService.DEFAULT_SERVICE_PATH = 'payments';
SettlementLineService.BASE_PATH = 'api/settlement-line';
//# sourceMappingURL=SettlementLineService.js.map